import React, { useState, useEffect, Key } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { IMaterialBase, IMaterialDetail, IMaterialSearchFields, materialService } from "../../../../base/material/materialService"
import { PaginationProps } from "antd/es/pagination";
import { globalPrompt } from "@/components/message";
import { IPurchasePoFields, IDetailList, IPurchasePoDetail, IPurchasePoSearch, Detailed } from "../../purchasePoType"
import { purchasePoService } from "../../purchasePoService"
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IShelfFileds } from "../../../../base/warehouse/warehouseService"
import { useDictModel } from "../../../../base/dict/dictModel";
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
import { transPgToPagination, formatNum } from "@/utils/utils";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useLockFn } from "ahooks";
//这里为了继承一个弹框列表的自定义属性值
export interface IMaterialDetailModel extends IMaterialDetail {
    num: number,
    taxPrice?: number,
    amount?: number | string
}
export type ISCMPoDescType = {
    numAll: number,
    itemNumAll: number,
    totalAll: number,
    [key: string]: any
}
export enum ITaxRateCodeEnum {
    TAX17 = "1.7"
}
export const usePurchasePoDetailsModel = createModel(function () {
    const { getTreeNodeName, getTreeNodeOne } = useDictModel();
    const { supplieAllList, user, setLocale } = useGlobalModel()
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const Locale = setLocale(LanguageArr)

    const [addModalVisible, setAddModalVisible] = useState<boolean>(false)  //新增商品弹框
    const initDesc = {
        numAll: 0,  //数量
        itemNumAll: 0, //项数
        totalAll: 0 //总计
    }
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initSearchParam: IMaterialSearchFields = {};
    //新增数据
    //新增详情form
    const initForm = {
        taxRateCode: ITaxRateCodeEnum.TAX17
        // taxRateCode: ''
    }
    const [detailAddForm, setDetailAddForm] = useState<IPurchasePoFields>(initForm)
    //新增详情列表
    const [detailAddList, setDetailAddList] = useState<IDetailList[]>([])
    //新增详情列表选中行
    const [detaiAddDataRowKeys, setDetaiAddDataRowKeys] = useState<Key[]>([]);
    const [detaiAddDataRow, setDetaiAddDataRow] = useState<IDetailList[]>([]);
    const [addDesc, setAddDesc] = useState<ISCMPoDescType>(initDesc)
    //是否含税
    const [taxincluded, setTaxincluded] = useState<boolean>(false); //存取是否含税 
    //查看数据
    //查看详情form
    const [detailLookForm, setDetailLookForm] = useState<IPurchasePoFields>({})
    //查看详情列表
    const [detailLookList, setDetailLookList] = useState<IDetailList[]>([])
    const [lookDesc, setLookDesc] = useState<ISCMPoDescType>(initDesc)

    //详情数据
    //详情列表参数
    const [detailDataSource, setDetailDataSource] = useState<IDetailList[]>([]);
    //详情表格选中行
    const [detailDataRowKeys, setDetailDataRowKeys] = useState<Key[]>([]);
    const [detailDataRow, setDetailDataRow] = useState<IDetailList[]>([]);
    const [detailEditForm, setDetailEditForm] = useState<IPurchasePoFields>({})
    const [editDesc, setEditDesc] = useState<ISCMPoDescType>(initDesc)
    //实时详情列表货位数据
    const [shelfAllList, setShelfAllList] = useState<IShelfFileds[]>([])

    //配件列表配置
    const [workDataSource, setWorkDataSource] = useState<IMaterialDetailModel[]>([])
    const [searchWorkData, setSearchWorkData] = useState<IMaterialSearchFields>(initSearchParam)
    const [workPgCfg, setWorkPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //已选配件列表
    const [addDataSource, setAddDataSource] = useState<IMaterialDetailModel[]>([]);

    //设置底部总数展示（查看|编辑|查看）
    useEffect(() => {
        let newDesc: ISCMPoDescType = { ...initDesc };
        detailDataSource && detailDataSource.forEach(item => {
            newDesc.numAll += Number(item.num);
            newDesc.totalAll += Number(item.taxPrice) * Number(item.num);
        });
        newDesc.itemNumAll = detailDataSource && detailDataSource.length
        setEditDesc(newDesc);
    }, [detailDataSource, taxincluded])

    useEffect(() => {
        let newDesc: ISCMPoDescType = { ...initDesc };
        detailAddList && detailAddList.forEach(item => {
            newDesc.numAll += Number(item.num);
            newDesc.totalAll += Number(item.num) * Number(item.taxPrice);
        });
        newDesc.itemNumAll = detailAddList && detailAddList.length
        setAddDesc(newDesc);
    }, [detailAddList, taxincluded])

    useEffect(() => {
        let newDesc: ISCMPoDescType = { ...initDesc };
        detailLookList && detailLookList.forEach(item => {
            newDesc.numAll += Number(item.num);
            newDesc.totalAll += Number(item.num) * Number(item.taxPrice);
        });
        newDesc.itemNumAll = detailLookList && detailLookList.length
        setLookDesc(newDesc);
    }, [detailLookList, taxincluded])

    //新增表单缓存
    const updateAddFormVal = (val: IPurchasePoFields) => {
        let newVal = val
        if ("supplierCode" in val) {
            let { name, typeCode, typeName, contact, phone } = getFindItem(val.supplierCode as string, supplieAllList)
            newVal = { ...val, contact, phone, supplierName: name, supplierTypeCode: typeCode, supplierTypeName: typeName }
        }
        setDetailAddForm({ ...detailAddForm, ...newVal })
    }
    //编辑表单缓存
    const updatEditFormVal = (val: IPurchasePoFields) => {
        let newVal = val
        if ("supplierCode" in val) {
            let { name, typeCode, typeName, contact, phone } = getFindItem(val.supplierCode as string, supplieAllList)
            newVal = { ...val, contact, phone, supplierName: name, supplierTypeCode: typeCode, supplierTypeName: typeName }
        }
        setDetailEditForm({ ...detailEditForm, ...newVal })
    }
    //获取一条编辑或查看数据
    const getDetailEditOne = async (id: string, pattern: string) => {
        let { retData } = await purchasePoService.one(id);
        const { details, ...from } = retData
        console.log(getTreeNodeOne(from.taxRate as any))
        if (retData && pattern == "edit") {
            setDetailDataSource(details as IDetailList[] ?? [])
            setDetailEditForm(from)
        } else if (retData && pattern == "look") {
            setDetailLookForm(from);
            setDetailLookList(details as IDetailList[] ?? [])
        }
    }
    //关闭弹框
    const resetWorkloadData = async () => {
        setSearchWorkData({});
        workloadData(initPgCfg, {});
    }
    //加载配件数据
    const workloadData = async (page?: ISearchPage, searchValue: IMaterialSearchFields = searchWorkData) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? workPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? workPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await materialService.page(searchParams);
        const { records, ...pg } = retData;
        const newRecords = records.map(item => {
            return {
                ...item,
                num: 1,
                amount: item.purchasePrice * 1,
            }
        })
        setWorkPgCfg(transPgToPagination(pg));
        setWorkDataSource(newRecords);
    }
    //筛选模块详情 详情和新增的列表已有数据的方法
    const modelScreenMethod = async (modelList: IMaterialDetailModel[], detailList: IDetailList[], mode: string) => {
        console.log(modelList, detailList)
        const repetition: string[] = [];
        const newDetailData: IMaterialDetailModel[] = []
        let { taxRateCode } = mode == "add" ? detailAddForm : detailEditForm;
        modelList.forEach(Item => {
            let isSelect = detailList && detailList.find(item => item.materialCode === Item.code);
            if (isSelect === undefined) {
                newDetailData.push({
                    ...Item,
                    materialCode: Item.code ?? Item.materialCode,
                    materialName: Item.name ?? Item.materialName,
                    materialNameEn: Item.nameEn ?? Item.materialNameEn,
                    price: Item.purchasePrice ?? Item.price,
                    taxPrice: taxincluded ? (+formatNum(Item.purchasePrice * Number(taxRateCode)) ?? +formatNum(Number(Item.price) * Number(taxRateCode))) : (Item.purchasePrice ?? Item.price),
                    amount: taxincluded ? +formatNum(Number(Item.amount) * Number(taxRateCode)) : Item.amount,
                    id: "",
                    // warehouseName:
                });
            } else {
                repetition.push(Item.name);
            }
        })
        return { newDetailData, repetition }
    }
    //添加到详情列表
    const transformsToPoDetailList = async (mode: string) => {
        //添加列表
        if (mode == "add") {
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailAddList, mode)
            setDetailAddList([...detailAddList, ...newDetailData])
            // repetition.length != 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            repetition.length != 0 && globalPrompt("message", { text: `${Locale["The material name of"]}${repetition.join(",")}${Locale["is repeated and will not be added."]}`, type: "warning" });

        } else if (mode == "edit") {
            //详情列表
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailDataSource, mode)
            setDetailDataSource([...detailDataSource, ...newDetailData])
            // repetition.length != 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            repetition.length != 0 && globalPrompt("message", { text: `${Locale["The material name of"]}${repetition.join(",")}${Locale["is repeated and will not be added."]}`, type: "warning" });

        }
    }

    //删除详情列表数据
    const detailDetailList = async (mode: string) => {
        if (mode == "add") {
            const filterDetailList = detailAddList.filter(el => !!!detaiAddDataRowKeys.find(ele => ele === el.materialCode))
            setDetailAddList(filterDetailList)
            // globalPrompt("message", { text: `删除成功`, type: "success" });
            globalPrompt("message", { text: Locale["Successfully deleted"], type: "success" });
            setDetaiAddDataRowKeys([]);
            setDetaiAddDataRow([]);
        } else if (mode == "edit") {
            const backendDetailList: any = detailDataRow.reduce((all, next) => {  //前端页面维护的需要删除的id
                if (next.id) {
                    all.push({ id: next.id });
                }
                return all;
            }, []);

            //删除详情列表调用的方法
            const deleteData = () => {
                const filterDetailList = detailDataSource.filter(el => !!!detailDataRowKeys.find(ele => ele === el.materialCode))
                console.log(filterDetailList)
                setDetailDataSource(filterDetailList)
                // globalPrompt("message", { text: `删除成功`, type: "success" });
                globalPrompt("message", { text: Locale["Successfully deleted"], type: "success" });
                setDetailDataRowKeys([]);
                setDetailDataRow([]);
            }

            if (backendDetailList.length > 0) {
                await purchasePoService.materialDelete({ ids: backendDetailList }).then(res => {
                    if (res.retData) {
                        deleteData()
                    } else {
                        // globalPrompt("message", { text: `删除失败`, type: "success" });
                        globalPrompt("message", { text: Locale["Unsuccessfully deleted"], type: "success" });
                    }
                })
            } else {
                deleteData()
            }


        }
    }
    //新增采购单
    const insertDetail = useLockFn(async (params: IPurchasePoFields) => {
        let newParams = {
            ...params,
            supplierName: getFindItem(params.supplierCode as string, supplieAllList).name,
            supplierTypeName: getTreeNodeName(params.supplierTypeCode as string),
            details: detailAddList,
            createUser: user.username,
            // taxRate: +getTreeNodeName(params.taxRateCode as string)
            taxRate:params.taxRateCode
        }
        let { retData } = await purchasePoService.insert(newParams);
        return retData;
    })
    //编辑采购单
    const editDetail = useLockFn(async (params: IPurchasePoFields) => {
        let newParams = {
            ...params,
            supplierName: getFindItem(params.supplierCode as string, supplieAllList).name,
            supplierTypeName: getTreeNodeName(params.supplierTypeCode as string),
            details: detailDataSource,
            updateUser: user.username,
            // taxRate: +getTreeNodeName(params.taxRateCode as string)
            taxRate:params.taxRateCode
        }
        let { retData } = await purchasePoService.update(newParams);
        return retData;
    })
    //结算操作
    const Settle = useLockFn(async (data: IPurchasePoFields) => {
        const params = {
            reckoner: user.username,
            ...data
        }
        let { retData } = await purchasePoService.settl(params);
        return retData
    })
    //出库操作
    const WhConfirm = useLockFn(async (data: IPurchasePoFields) => {
        const params = {
            storekeeper: user.username,
            ...data
        }
        let { retData } = await purchasePoService.warehousing(params);
        return retData
    })
    //下载模板 
    const onExport = async () => {
        let result = await purchasePoService.downloadTpl();
        convertRes2Blob(result);

    }
    //关闭页签清不同状态缓存
    const resetAddCatch = async (type: string) => {
        setDetailAddList([]);
        setDetailAddForm({})
    }
    const resetEditCatch = async (type: string) => {
        setDetailEditForm({});
        setDetailDataSource([]);
    }


    //商品进销存明细
    const [materialHistoryModel, setMaterialHistoryModel] = useState<boolean>(false); //商品进销存明细弹框 
    const [materialHistoryRow, setMaterialHistoryRow] = useState<IDetailList>({}); //商品进销存明细弹框 
    const [materialHistoryType, setMaterialHistoryType] = useState<string>("trade-type.purchase")//trade-type.sale-order 查询历史状态
    return {
        addModalVisible,
        addDataSource,
        workDataSource,
        searchWorkData,
        workPgCfg,
        detailDataSource,
        detailDataRowKeys,
        detailDataRow,
        detailAddList,
        detaiAddDataRowKeys,
        detaiAddDataRow,
        detailLookForm,
        detailLookList,
        detailEditForm,
        detailAddForm,
        addDesc,
        lookDesc,
        editDesc,
        shelfAllList,
        setAddDesc,
        setLookDesc,
        setEditDesc,
        setDetailAddForm,
        setDetaiAddDataRowKeys,
        setDetailAddList,
        setDetailDataRow,
        setDetailDataRowKeys,
        setWorkDataSource,
        setSearchWorkData,
        setWorkPgCfg,
        setAddModalVisible,
        setAddDataSource,
        workloadData,
        transformsToPoDetailList,
        setDetailDataSource,
        resetWorkloadData,
        detailDetailList,
        updateAddFormVal,
        updatEditFormVal,
        setDetaiAddDataRow,
        setDetailLookForm,
        setDetailLookList,
        setDetailEditForm,
        getDetailEditOne,
        insertDetail,
        editDetail,
        Settle,
        WhConfirm,
        setShelfAllList,
        modelScreenMethod,
        onExport,
        resetAddCatch,
        resetEditCatch,
        materialHistoryModel,
        setMaterialHistoryModel,
        materialHistoryRow,
        setMaterialHistoryRow,
        materialHistoryType,
        setMaterialHistoryType,
        initForm,
        taxincluded, setTaxincluded,
        initPgCfg
    }
});